<template>
  <span>
    <a v-if="subscriptionId" :href="subscriptionUrl(subscriptionId)" target="_blank">
      {{ subscriptionId }}
    </a>
    <span v-if="subscription">
      <a v-if="subscription.id" :href="subscriptionUrl(subscription.id)" target="_blank">
        {{ subscription.id }}
      </a>
      <span v-if="subscription.status"> ({{ subscription.status }})</span>
      <span v-if="!subscription.status">not set</span>
    </span>
  </span>
</template>
<script type="ts">
import Vue from 'vue';
import StripeSubscription from '@/datatypes/stripe/subscription';

export default Vue.extend({
  name: 'subscription-text',
  props: {
    subscriptionId: {
      type: String,
      default: '',
    },
    subscription: {
      type: StripeSubscription,
      default: undefined,
    },
  },
  methods: {
    subscriptionUrl(subscriptionId) {
      return this.$billingProviderUrl[process.env.VUE_APP_PROVIDER].subscription(subscriptionId);
    },
  },
});
</script>
